export class RequestShiftPreviewDto {
  startDate: string;
  endDate: string;
  companyId: number;
  emailUser: string;
  fullName: string;
  sendEmail: boolean;
  allEmp: number;
  listEmp: any[];
}

export class RequestShiftDownloadExcelDto {
  startDate: string;
  endDate: string;
  companyId: number;
  emailUser: string;
  fullName: string;
  sendEmail: boolean;
  allEmp: number;
  listEmp: any[];
}

export class RequestShiftDownloadPdfDto {
  startDate: string;
  endDate: string;
  companyId: number;
  emailUser: string;
  fullName: string;
  sendEmail: boolean;
  allEmp: number;
  listEmp: any[];
}

export class RequestShiftSendPdfDto {
  startDate: string;
  endDate: string;
  companyId: number;
  emailUser: string;
  fullName: string;
  sendEmail: boolean;
  allEmp: number;
  listEmp: any[];
}

export class RequestShiftSendExcelDto {
  startDate: string;
  endDate: string;
  companyId: number;
  emailUser: string;
  fullName: string;
  sendEmail: boolean;
  allEmp: number;
  listEmp: any[];
}

export class ResponseShiftPreviewDto {
  message: string;
  data?: any;
}

export class ResponseShiftSendPdfDto {
  message: string;
  data?: any;
}

export class ResponseShiftSendExcelDto {
  message: string;
  data?: any;
}


// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/dto/shiftschedule-report.dto.ts